// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/**
 * Database icon with a "+" badge.
 * Fully Lucide-compatible (accepts all SVG props, inherits currentColor).
 */
export function DatabasePlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 18h6" />
      <path d="M19 15v6" />
      <path d="M21 11.693V5" />
      <path d="M3 12A9 3 0 0 0 13.39 14.87" />
      <path d="M3 5V19A9 3 0 0 0 14 21.84" />
      <ellipse cx="12" cy="5" rx="9" ry="3" />
    </svg>
  );
}
